import Inherit from '../../../core/inherit';
import AnalyticsDelegate from './analytics.delegate';
import ShelfController from '../../../core/shelf.controller';
import { t } from '../../../company/labels';

class PromotorAnalyticsController extends Inherit(ShelfController, AnalyticsDelegate) {
    async initialize() {
        if (!this.isAuthenticated) {
            this.navigateLogin();
            return;
        }

        this.setState({ loading: true });
        // Load tags first, then analytics
        await this.loadTags();
        await this.loadAnalytics();
    }

    async loadTags() {
        try {
            const tagsData = await this.data.fetchTags({ modelType: 'User' });
            if (tagsData?.success && tagsData.tags) {
                // Tags are already filtered by modelType in the backend
                this.setState({ tags: tagsData.tags });
            }
        } catch (error) {
            console.error('Error loading tags:', error);
            this.setState({ tags: [] });
        }
    }

    async loadAnalytics() {
        try {
            const { period, limit, channel, tagId, startDate, endDate } = this.state;
            const effectiveTagId = tagId === 'all' ? null : tagId;
            const analyticsData = await this.data.fetchPromotorAnalytics(period, limit, channel, effectiveTagId, startDate, endDate);

            if (analyticsData?.success) {
                const { topPromotors, inactivePromotors, totalPromotors, activePromotors, inactiveCount } = analyticsData.data;

                this.setState({
                    topPromotors,
                    inactivePromotors,
                    totalPromotors,
                    activePromotors,
                    inactiveCount,
                    loading: false
                });
            } else {
                this.setState({
                    topPromotors: [],
                    inactivePromotors: [],
                    totalPromotors: 0,
                    activePromotors: 0,
                    inactiveCount: 0,
                    loading: false
                });
            }
        } catch (error) {
            console.error('Error loading promotor analytics:', error);
            const { onMessage } = this.props;
            onMessage('error', `Error al cargar las analíticas de ${t('promotoresLower')}`);
            this.setState({ loading: false });
        }
    }

    changePeriod(newPeriod) {
        console.log('🔄 Changing period to:', newPeriod);
        this.setState({ period: newPeriod, loading: true }, () => {
            // Force immediate re-render and then load data
            this.forceUpdate();
            setTimeout(async () => {
                await this.loadAnalytics();
            }, 10);
        });
    }

    changeLimit(newLimit) {
        console.log('🔄 Changing limit to:', newLimit);
        this.setState({ limit: newLimit, loading: true }, () => {
            // Force immediate re-render and then load data
            this.forceUpdate();
            setTimeout(async () => {
                await this.loadAnalytics();
            }, 10);
        });
    }

    changeChannel(newChannel) {
        console.log('🔄 Changing channel to:', newChannel);
        this.setState({ channel: newChannel, loading: true }, () => {
            // Force immediate re-render and then load data
            this.forceUpdate();
            setTimeout(async () => {
                await this.loadAnalytics();
            }, 10);
        });
    }

    changeTag(newTagId) {
        console.log('🔄 Changing tag to:', newTagId);
        this.setState({ tagId: newTagId, loading: true }, () => {
            this.forceUpdate();
            setTimeout(async () => {
                await this.loadAnalytics();
            }, 10);
        });
    }

    changeDateRange(startDate, endDate) {
        console.log('🔄 Changing date range to:', { startDate, endDate });
        this.setState({ startDate, endDate, loading: true }, () => {
            this.forceUpdate();
            setTimeout(async () => {
                await this.loadAnalytics();
            }, 10);
        });
    }

    navigateToPromoter(promotorId) {
        this.props.navigate(`/dashboard/trade/promoter?id=${promotorId}`);
    }

    goBackToPromotors() {
        this.props.navigate('/dashboard/trade/promoters');
    }
}

export default PromotorAnalyticsController;
